import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import "./styles/App.css";
import queryString from "query-string";
import { instance } from "./common";
import parse from "html-react-parser";

function NoticeDetail({ history, location }) {
    const query = queryString.parse(location.search);
    let n_id = query.n_id;

    const [data, setData] = useState([]);

    let obj = {
        n_id: n_id,
    };

    useEffect(() => {
        const fetchData = () => {
            instance.post("/notice/id", obj).then(function (res) {
                // console.log('res.data : ', res.data);
                setData(res.data[0]);
            });
        };

        fetchData();
    }, []);
    //   console.log('data : ', data);
    let { n_content, n_date, n_title } = data;

    if (n_content) {
        n_content = parse(n_content);
    }

    const goLink = () => history.push("/noticelist");

    return (
        <Container>
            <h2 className="nd_title">공지사항</h2>
            <div className="nd_header ">
                <h4 className="nd_header__title ">{n_title}</h4>
                <span className="nd_header__desc">작성일 | {n_date}</span>
            </div>
            <div className="nd_body">{n_content}</div>
            <div className="btn s_service_btn" onClick={goLink}>
                목록
            </div>
        </Container>
    );
}

export default NoticeDetail;
